import { useGroupSlug } from "@/hooks/use-group-slug";
import { Gate } from "./Gate";

type TestGroupGateProps = {
  children: React.ReactElement;
  notTestGroup?: boolean;
};

const TEXT_GROUP_SLUG = ["test", "test-a", "test-b"];

export const TestGroupGate: React.FC<TestGroupGateProps> = ({
  children,
  notTestGroup = false,
}) => {
  const groupSlug = useGroupSlug(false);
  if (!groupSlug) {
    return null;
  }

  return (
    <Gate
      name="TestGroupGate"
      description={
        notTestGroup ? `Gate for non-test group.` : `Gate for test group.`
      }
      value={groupSlug}
      equals={notTestGroup ? undefined : TEXT_GROUP_SLUG}
      notEquals={notTestGroup ? TEXT_GROUP_SLUG : undefined}
      disableImmunity
    >
      {children}
    </Gate>
  );
};
